import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'vtr-widget-energy-star',
	templateUrl: './widget-energy-star.component.html',
	styleUrls: ['./widget-energy-star.component.scss']
})
export class WidgetEnergyStarComponent implements OnInit {

	constructor() { }

	ngOnInit(): void {
	}

}
